<template lang="pug">
  b-container(fluid)
    .d-flex.align-items-center
    .text-center
      h2 {{name}}
    .text-center
      p Imagen para mostrar
      b-overlay(:show="loading", variant="transparent", spinner-variant="primary")
        b-avatar.mb-1(button, size="125", :src="profile_picture_url", v-b-tooltip="profile_picture_url ? 'Cambiar imagen' : 'Subir imagen'", @click="$refs.input_image.click()" )
    input.d-none(type="file", accept="image/*", ref="input_image", @change="imagePicked")
    b-container.text-left.pt-3.pt-lg-0(lg="12")
        b-col.mb-2(md="12")
          b-form-group(label="Descripción", label-size="sm")
            b-form-input(placeholder="Descripción", v-model="description", size="sm", maxlength="512" )
        b-col.mb-2(md="12")
          b-form-group(label="Dirección", label-size="sm")
            b-form-input(placeholder="Dirección", v-model="address", size="sm", maxlength="256")
        b-col.mb-2(md="12")
          b-form-group(label="Email", label-size="sm")
            b-form-input(placeholder="Correo", v-model="email", size="sm", maxlength="128" )      
        b-col.mb-2(md="12")
          b-form-group(label="Website", label-size="sm")
            b-form-input(placeholder="Sitio web", v-model="website", size="sm", maxlength="256")                  
        b-col.text-right.pt-3.pt-lg-0(lg="12")
          b-button(variant="primary", @click="updateWhatsappProfileInfo") Actualizar
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      profile_picture_url: '',
      description: '',
      email: '',
      website: '',
      address: ''
    }
  },
  props: {
    name: {
      default: ''
    },
    waba_id: {
      default: null
    },
    model_id: {
      default: null
    }
  },
  methods: {
    ...mapActions(['whatsapp/get_profile', 'whatsapp/upload_file', 'whatsapp/update_profile']),
    getWhatsappProfile () {
      let self = this
      this.loading = true
      this['whatsapp/get_profile']({
        model_id: self.model_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            console.log(res)
            if(res.resource && res.resource.length) {
              this.profile_picture_url = res.resource[0].profile_picture_url
              this.description = res.resource[0].description ? res.resource[0].description : ""
              this.email = res.resource[0].email ? res.resource[0].email : ""
              this.website = res.resource[0].websites ? res.resource[0].websites[0] : ""
              this.address = res.resource[0].address ? res.resource[0].address : ""
            }
          }
          self.loading = false
        }
      })
    },
    updateWhatsappProfileInfo () {
      let self = this
      this.loading = true
      this['whatsapp/update_profile']({
        description: this.description,
        email: this.email,
        website: this.website,
        address: this.address,
        model_id: self.model_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Whatsapp actualizado')
          }
        }
      })
    },
    updateWhatsappProfile(handle) {
      let self = this
      this.loading = true
      this['whatsapp/update_profile']({
        profile_picture_handle: handle,
        model_id: self.model_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Whatsapp actualizado')
          }
        }
      })
    },
    async imagePicked (event) {
      this.loading = true
      let file = event.target.files[0]
      this.profile_picture_url = URL.createObjectURL(file)
      const handle = await this.getFileHandle(file)
      if(handle) {
        this.updateWhatsappProfile(handle)
      } else {
        this.$message.warning('No logramos subir el archivo, por favor comprueba tu conexión a internet')
      }
      this.$refs.input_image.value = ''
    },
    getFileHandle (file) {
      let self = this
      return new Promise(resolve => {
        let form = new FormData()
        form.append('file', file)
        this['whatsapp/upload_file']({
          waba_id: this.waba_id,
          form: form,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
              return resolve(false)
            } else {
              return resolve(res.resource)
            }
          }
        });
      })
    },
  },
  mounted () {
    this.getWhatsappProfile()
  }
}
</script>

<style lang="scss" scoped>
  .menu-item {
    position: relative;
    box-sizing: border-box;
    &:hover {
      .menu-delete {
        display: inline-block;
      }
    }
  }

  .menu-actions {
    position: absolute;
    right: 5px;
  }

  .menu-delete {
    display: none;
  }

  .whitelist-container {
    max-height: 400px;
  }
</style>
